import { apiClient } from 'utils/api-client'
import { getAuthHeader } from 'utils/auth'
import { notificationToast } from 'components'

 const downloadInvoice = async (invoiceId) => {
	let headers = getAuthHeader()
	try {
		let result = await apiClient(`/payment/invoice/${invoiceId}`, {
			headers,
			responseType: 'arraybuffer'
		})
		if (result && result.data) {
			const file = new Blob([result.data], { type: 'application/pdf' })
			const fileURL = URL.createObjectURL(file)
			const link = document.createElement('a')
			link.href = fileURL
			link.download = `invoice-"${new Date()}.pdf`
			link.click()
		}
	} catch (error) {
		error = error.response && error.response.data
		let parsedError = Buffer.from(error).toString('utf8')
		let err =
			parsedError && parsedError !== '' ? JSON.parse(parsedError) : { Errors: 'Error while trying to download file' }
		notificationToast({
			message: 'Error',
			description: `${err.Errors}`,
			icontype: 'alert'
		})
	}
}
export default downloadInvoice;